import { SECOND_AS_MILLISECONDS } from 'enum/timeFormat';


type TimerCallback = (time: number) => void;

export class SecondsTimer {
  secondsElapsed: number = 0;
  currentTimestamp: number = undefined;
  startTimestamp: number = undefined;
  timerHandler: ReturnType<typeof setInterval> = null;

  /**
   * Start timer
   * @param callback - Callback called each second
   * @param fixedTime - number of seconds
   * @param startTime - the time in ms since when to start the timer
   */
  start(callback: TimerCallback, fixedTime: number, startTime: number) {
    this.secondsElapsed = 0;
    this.currentTimestamp = Date.now();
    this.startTimestamp = startTime || this.currentTimestamp;
    this.timerHandler = setInterval(this.processTime, SECOND_AS_MILLISECONDS / 2, callback, fixedTime);
  }

  /** Stop timer */
  stop() {
    clearInterval(this.timerHandler);
  }

  private processTime = (callback: TimerCallback, fixedTime: number) => {
    this.currentTimestamp = Date.now();
    const secondsElapsedNew = Math.floor((this.currentTimestamp - this.startTimestamp) / SECOND_AS_MILLISECONDS);
    if (secondsElapsedNew > this.secondsElapsed) {
      this.secondsElapsed = secondsElapsedNew;
      if (fixedTime) {
        callback(fixedTime - this.secondsElapsed);
      } else {
        callback(this.secondsElapsed);
      }
    }
  };
}
